"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTop = void 0;
const react_1 = __importDefault(require("react"));
const Breadcrumbs_1 = __importDefault(require("app/Components/Shared/Breadcrumbs"));
const PageTop = (props) => {
    var _a, _b, _c;
    if (props.layoutSettings === undefined)
        return null;
    if (!props.showNews && !props.breadCrumbsProps)
        return null;
    const fontClass = props.fontWhite ? 'white' : '';
    const bannerText = ((_a = props.layoutSettings.bannerText) === null || _a === void 0 ? void 0 : _a.value) || ((_b = props.layoutSettings.bannerText) === null || _b === void 0 ? void 0 : _b.value) !== `<p></p>`
        ? (_c = props.layoutSettings.bannerText) === null || _c === void 0 ? void 0 : _c.value : props.layoutSettings.bannerText;
    return react_1.default.createElement("div", { className: `page-top ${fontClass} d-none d-md-block position-absolute w-100 top-0 content-padding` },
        react_1.default.createElement(Breadcrumbs_1.default, { currentContent: props.breadCrumbsProps, hidden: props.showNews || !props.breadCrumbsProps, lang: props.lang }),
        props.showNews &&
            react_1.default.createElement("div", { className: 'col-12 latest-news-content py-3' },
                react_1.default.createElement("div", { suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: bannerText } })));
};
exports.PageTop = PageTop;
exports.default = exports.PageTop;
